var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustrationRegister = function SvgIllustrationRegister(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 330 434"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-register_svg__a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-register_svg__b)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7E6F5",
    d: "m14.91 379.069 136.788 49.771a44.888 44.888 0 0 0 29.61 0l134.554-49.738c5.922-2.168 5.825-7.508 0-9.708l-142.386-50.385a25.327 25.327 0 0 0-16.374 0L14.911 369.426c-5.922 2.201-5.955 7.508 0 9.643"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__c)",
    d: "m17.294 327.048 136.788 49.77a44.876 44.876 0 0 0 29.61 0l134.554-49.738c5.922-2.168 5.825-7.507 0-9.708L175.86 266.987a25.34 25.34 0 0 0-16.374 0L17.294 317.405c-5.921 2.2-5.954 7.507 0 9.643",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__d)",
    d: "m17.283 305.55 136.787 49.77a44.876 44.876 0 0 0 29.61 0l134.554-49.738c5.922-2.168 5.825-7.507 0-9.708l-142.385-50.385a25.343 25.343 0 0 0-16.375 0L17.283 295.907c-5.922 2.2-5.955 7.507 0 9.643",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "m17.295 282.034 136.787 49.771a44.888 44.888 0 0 0 29.61 0l134.555-49.738c5.921-2.168 5.824-7.508 0-9.708l-142.386-50.386a25.343 25.343 0 0 0-16.375 0L17.295 272.391c-5.922 2.136-5.955 7.475 0 9.643",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__e)",
    d: "M167.705 309.735c61.784 0 111.87-14.908 111.87-33.298 0-18.391-50.086-33.299-111.87-33.299-61.784 0-111.87 14.908-111.87 33.299 0 18.39 50.086 33.298 111.87 33.298",
    opacity: 0.89,
    style: {
      mixBlendMode: "lighten"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-register_svg__f)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__g)",
    d: "M279.575 6.972H55.835v269.465h223.74z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__h)",
    d: "M102.498 85.93a7.768 7.768 0 0 1 7.767 7.767v78.733H94.764V93.665a7.766 7.766 0 0 1 7.734-7.734"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__i)",
    d: "M164.358 156.641a7.769 7.769 0 0 1 7.767 7.766v78.798h-15.533v-78.798c0-2.06.818-4.035 2.274-5.492a7.769 7.769 0 0 1 5.492-2.274"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__j)",
    d: "M83.697 198.998a3.888 3.888 0 0 1 3.588 2.397c.195.471.296.976.296 1.486v39.351h-7.767v-39.351a3.885 3.885 0 0 1 3.883-3.883"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__k)",
    d: "M238.269 50.564a7.768 7.768 0 0 1 7.767 7.766v78.701h-15.533V58.298a7.768 7.768 0 0 1 7.766-7.767z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__l)",
    d: "M216.425 98.457a7.765 7.765 0 0 1 7.767 7.767v78.732h-15.501v-78.732a7.766 7.766 0 0 1 7.734-7.767"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "m160.353 234.934 14.512-4.862 29.384 9.319-14.878 4.726z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__m)",
    d: "M160.353 234.935v18.957l29.019 9.582v-19.357z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__n)",
    d: "M204.249 239.392v19.169l-14.877 4.913v-19.357z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5CCB",
    d: "m172.875 238.787-.049-.167-.126.037v.13zm14.864-4.19a.174.174 0 0 0 .118-.216.174.174 0 0 0-.216-.119zm-14.69 23.363v-19.173h-.349v19.173zm-.125-19.006 14.815-4.357-.098-.335-14.815 4.358z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "m113.292 168.39 12.754-4.273 25.822 8.19-13.074 4.152z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__o)",
    d: "M113.292 168.39v16.659l25.501 8.421v-17.011z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__p)",
    d: "M151.867 172.307v16.845l-13.074 4.318v-17.011z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5CCB",
    d: "m124.297 171.776-.044-.147-.109.032v.115zm13.062-3.683a.153.153 0 0 0-.086-.294zm-12.909 20.531v-16.848h-.306v16.848zm-.11-16.702 13.019-3.829-.086-.294-13.02 3.83z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "m125.263 153.073 12.753-4.273 25.822 8.189-13.074 4.153z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__q)",
    d: "M125.263 153.072v16.66l25.501 8.42v-17.011z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-register_svg__r)",
    d: "M163.838 156.989v16.846l-13.074 4.318v-17.011z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5CCB",
    d: "m136.267 156.458-.043-.147-.11.033v.114zm13.063-3.682a.153.153 0 0 0 .103-.19.153.153 0 0 0-.19-.104zm-12.91 20.531v-16.849h-.306v16.849zm-.11-16.702 13.02-3.829-.087-.294-13.019 3.829z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__c",
    x1: 12.829,
    x2: 322.615,
    y1: 322.453,
    y2: 322.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#CFDEFF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1DFFF",
    stopOpacity: 0.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__d",
    x1: 12.829,
    x2: 322.603,
    y1: 297.491,
    y2: 300.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#CFDEFF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1DFFF",
    stopOpacity: 0.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__g",
    x1: 166.982,
    x2: 167.705,
    y1: 24.759,
    y2: 276.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FFCA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#AEEA73",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#AEEA73",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#AEEA73",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6FFCE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__h",
    x1: 102.304,
    x2: 102.692,
    y1: 196.83,
    y2: 79.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AEEA73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AEEA73",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AEEA73",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AEEA73",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AEEA73",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEEA73",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__i",
    x1: 164.132,
    x2: 164.52,
    y1: 267.54,
    y2: 150.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AEEA73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AEEA73",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AEEA73",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AEEA73",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AEEA73",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEEA73",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__j",
    x1: 83.6,
    x2: 83.794,
    y1: 254.464,
    y2: 195.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AEEA73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AEEA73",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AEEA73",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AEEA73",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AEEA73",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEEA73",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__k",
    x1: 238.043,
    x2: 238.431,
    y1: 161.463,
    y2: 44.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AEEA73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AEEA73",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AEEA73",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AEEA73",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AEEA73",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEEA73",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__l",
    x1: 216.231,
    x2: 216.62,
    y1: 209.356,
    y2: 92.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AEEA73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AEEA73",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AEEA73",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AEEA73",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AEEA73",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEEA73",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__m",
    x1: 174.862,
    x2: 174.862,
    y1: 234.935,
    y2: 263.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__n",
    x1: 196.811,
    x2: 196.811,
    y1: 239.392,
    y2: 263.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__o",
    x1: 126.043,
    x2: 126.043,
    y1: 168.39,
    y2: 193.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__p",
    x1: 145.33,
    x2: 145.33,
    y1: 172.307,
    y2: 193.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__q",
    x1: 138.014,
    x2: 138.014,
    y1: 153.072,
    y2: 178.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-register_svg__r",
    x1: 157.301,
    x2: 157.301,
    y1: 156.989,
    y2: 178.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-register_svg__b",
    width: 325.81,
    height: 129.702,
    x: 2.457,
    y: 309.649,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1417_107678",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-register_svg__f",
    width: 242.713,
    height: 288.438,
    x: 46.349,
    y: -2.515,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 4.743
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1417_107678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1417_107678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "illustration-register_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130.74913 7.06752 -1.72098 31.83812 166.556 278.116)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B4E188",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#BAD89B",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BED3A7",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD1AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-register_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h329.65v434H0z"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustrationRegister);
export default Memo;